/* Amariel Cart-Guard — zeigt Modal NUR wenn User das reguläre (paid)
   Magnesium aus dem Cart entfernt oder seine Menge so reduziert dass
   der Bundle-State ungültig wird. Sonst stumm.
*/
(function () {
  'use strict';

  var PAID_MAGS   = [57290272866681, 57330629017977, 63833080660345]; /* alt + Normal(€40) + Kur(€35 Abo) */
  var FREE_MAG    = 57330629050745;
  var FREE_MASKE  = 57330624364921;
  var FREE_NACKEN = 57329836032377;
  var FREEBIES    = [FREE_MAG, FREE_MASKE, FREE_NACKEN];

  var MODAL_ID = 'am-bundle-modal';
  var STYLE_ID = 'am-bundle-modal-style';

  var lastPaidQty = null;        // letzte bekannte paid Mag Menge
  var lastInvalid = false;       // letzter Validity-State

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent =
      '#' + MODAL_ID + '{position:fixed;inset:0;z-index:2147483647;display:none;align-items:center;justify-content:center;padding:20px;font-family:inherit;}' +
      '#' + MODAL_ID + '.active{display:flex;}' +
      '#' + MODAL_ID + ' .am-bm-backdrop{position:absolute;inset:0;background:rgba(0,0,0,.45);}' +
      '#' + MODAL_ID + ' .am-bm-dialog{position:relative;background:#2a2a2a;color:#fff;border-radius:16px;padding:28px 28px 20px;max-width:480px;width:100%;box-shadow:0 20px 60px rgba(0,0,0,.4);line-height:1.55;font-size:17px;}' +
      '#' + MODAL_ID + ' .am-bm-dialog p{margin:0 0 14px;}' +
      '#' + MODAL_ID + ' .am-bm-dialog p:last-of-type{margin-bottom:18px;}' +
      '#' + MODAL_ID + ' .am-bm-close{display:block;margin-left:auto;background:none;border:0;color:#4ea8ff;font-size:17px;font-weight:500;cursor:pointer;padding:8px 4px;font-family:inherit;}' +
      '#' + MODAL_ID + ' .am-bm-close:hover{opacity:.8;}';
    document.head.appendChild(s);
  }

  function ensureModal() {
    var m = document.getElementById(MODAL_ID);
    if (m) return m;
    m = document.createElement('div');
    m.id = MODAL_ID;
    m.setAttribute('role', 'dialog');
    m.setAttribute('aria-modal', 'true');
    m.innerHTML =
      '<div class="am-bm-backdrop" data-am-close></div>' +
      '<div class="am-bm-dialog">' +
        '<p>Die kostenlose Schlafmaske und das gratis Magnesium sind Teil eines Bundles und können nicht alleine bestellt werden.</p>' +
        '<p>Bitte füge mindestens <b>2× Amariel Magnesium (regulär)</b> hinzu, oder entferne die Bundle-Gratis-Artikel.</p>' +
        '<button type="button" class="am-bm-close" data-am-close>Schließen</button>' +
      '</div>';
    document.body.appendChild(m);
    m.addEventListener('click', function (e) {
      if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-am-close')) {
        m.classList.remove('active');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && m.classList.contains('active')) m.classList.remove('active');
    });
    return m;
  }

  function showModal() {
    /* Deaktiviert auf User-Wunsch: das Modal beim Entfernen von Artikeln erscheint nicht mehr.
       Schutz gegen €0-Checkout läuft weiter beim "Sicher zur Kasse"-Klick (cart-drawer.liquid). */
    return;
  }

  async function readCart() {
    var c = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
    var paid = 0, freeMag = 0, maske = 0, nacken = 0;
    c.items.forEach(function (it) {
      if (PAID_MAGS.indexOf(it.variant_id) >= 0) paid += it.quantity;
      else if (it.variant_id === FREE_MAG) freeMag += it.quantity;
      else if (it.variant_id === FREE_MASKE) maske += it.quantity;
      else if (it.variant_id === FREE_NACKEN) nacken += it.quantity;
    });
    var anyFree = freeMag > 0 || maske > 0 || nacken > 0;
    var need = Math.max(2, freeMag + 1);
    var invalid = anyFree && paid < need;
    return { paid: paid, freeMag: freeMag, maske: maske, nacken: nacken, invalid: invalid };
  }

  async function evaluate() {
    try {
      var s = await readCart();
      var paidWentDown = (lastPaidQty !== null) && s.paid < lastPaidQty;
      // Modal nur wenn:
      //   - paid Mag wurde gerade reduziert (entfernt oder weniger)
      //   - UND State ist jetzt invalid
      if (paidWentDown && s.invalid) {
        showModal();
      }
      lastPaidQty = s.paid;
      lastInvalid = s.invalid;
    } catch (_) {}
  }

  // Initial-Snapshot (ohne Modal — wir wollen nur Transitions tracken)
  async function initSnapshot() {
    try {
      var s = await readCart();
      lastPaidQty = s.paid;
      lastInvalid = s.invalid;
    } catch (_) {
      lastPaidQty = 0;
      lastInvalid = false;
    }
  }

  // 1) Fetch interception — alle Cart-Mutationen
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = '';
    try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (_) {}
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(change|update|clear)/i.test(url)) {
      // /add ignorieren — Modal soll nur beim Entfernen kommen, nicht beim Hinzufügen
      p.then(function () { setTimeout(evaluate, 300); }, function () {});
    } else if (/\/cart\/add/i.test(url)) {
      // Bei /add nur Snapshot updaten, ohne Modal-Check
      p.then(function () { setTimeout(initSnapshot, 300); }, function () {});
    }
    return p;
  };

  // 2) XHR interception
  var XOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__cartUrl = url || '';
    return XOpen.apply(this, arguments);
  };
  var XSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var u = this.__cartUrl || '';
    if (/\/cart\/(change|update|clear)/i.test(u)) {
      this.addEventListener('load', function () { setTimeout(evaluate, 300); });
    } else if (/\/cart\/add/i.test(u)) {
      this.addEventListener('load', function () { setTimeout(initSnapshot, 300); });
    }
    return XSend.apply(this, arguments);
  };

  // Init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(initSnapshot, 400); });
  } else {
    setTimeout(initSnapshot, 400);
  }

  console.log('[CartGuard] modal-on-removal active');
})();
